import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header bg-light" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "card-body p-0" }
const _hoisted_8 = {
  key: 0,
  class: "list-group"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "d-flex flex-column align-items-center m-4"
}
const _hoisted_11 = { class: "col-8" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = {
  key: 0,
  class: "card-header text-primary d-flex justify-content-between align-items-center"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "form-group m-0"
}
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = { class: "input-group-append" }
const _hoisted_18 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_playlist = _resolveComponent("create-playlist")!
  const _component_switch_input = _resolveComponent("switch-input")!
  const _component_play_list_component = _resolveComponent("play-list-component")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_create_playlist, { onCreate: _ctx.create }, {
              trigger: _withCtx((triggerProps) => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Playlists", -1)),
                  _createElementVNode("button", {
                    onClick: triggerProps.click,
                    class: "btn btn-sm btn-primary"
                  }, "Create", 8, _hoisted_6)
                ])
              ]),
              _: 1
            }, 8, ["onCreate"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.playlists.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlists, (item, index) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.selectedPlaylist = index),
                      key: index,
                      class: _normalizeClass(["list-group-item d-flex rounded-0 justify-content-between align-items-center list-group-item-action", {'active':index === _ctx.selectedPlaylist}])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.data.name), 1),
                      _createElementVNode("span", null, [
                        _cache[6] || (_cache[6] = _createTextVNode("Scenarios: ")),
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.selectedPlaylist === index ? 'badge-light' : 'badge-primary'])
                        }, _toDisplayString(item.data.scenarios.length), 3)
                      ])
                    ], 10, _hoisted_9))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "text-primary mb-4" }, "You Have no Playlist", -1)
                ])))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.playlists.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (!_ctx.editName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.playlists[_ctx.selectedPlaylist].data.name) + " ", 1),
                      _createElementVNode("a", {
                        class: "text-primary",
                        href: "javascript:void(0)",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editName = true))
                      }, _cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.playlists[_ctx.selectedPlaylist].data.name) = $event)),
                          class: "form-control form-control-sm"
                        }, null, 512), [
                          [_vModelText, _ctx.playlists[_ctx.selectedPlaylist].data.name]
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editName = false))
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fa fa-ban" }, null, -1)
                          ])),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-primary",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fa fa-save" }, null, -1)
                          ]))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_switch_input, {
                  label: "Public",
                  modelValue: _ctx.playlists[_ctx.selectedPlaylist].data.public,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.playlists[_ctx.selectedPlaylist].data.public) = $event)),
                    _ctx.updatePublic
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.playlists.length > 0)
              ? (_openBlock(), _createBlock(_component_play_list_component, {
                  key: 0,
                  playlist: _ctx.playlists[_ctx.selectedPlaylist]
                }, null, 8, ["playlist"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}